import React from 'react';

import Dropdown from "./ReactDropdown";
export default class DropdownDesignatedTeachers extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option
	//
	// defaultItemId : The user ID of the user to select, if supplied
	// user_id : The user ID of the ESW or user who is calling this
	
	static get defaultProps() 
	{
	    var v =
	    	{
		    	  defaultItemId: 0,
				  containerClassName: 'input-group',
		    	  value: 0
	    	} ;

	    	return v ;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

    	// Create a state item here
		this.state = {
			currentId: this.props.defaultItemId,
			valid: false,
			items: null,
			loading: true
		};
	}

	componentDidMount()
	{
		this.setState ({valid: this.isValueValid(this.props.value)}) ;

		this.getdata (this.props.school_id) ;
	}

	componentDidUpdate(prevProps)
	{
		if ( prevProps.school_id !== this.props.school_id )
		{
			this.state.loading = true ;
			this.state.currentId = this.props.defaultItemId;
			this.getdata ( this.props.school_id ) ;
		}

	}

	UNSAFE_componentWillReceiveProps( newProps )
	{
  	}

	componentWillUnmount()
	{
      this.setState({isMounted: false})
  	}

	getValue()
	{
		return this.state.currentId ;
	}

	/**
	* Returns true if the input value complies with the validation rules supplied
	*
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0 || param == -1)
				{
					if ( this.state.items == null )
					{
						return true ;
					}
					else
					{
						if ( this.state.items.length > 0)
						{
							return false ;
						}
						else
						{
							return false ;
						}
					}
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}
		}

		return true ;
	}

	/**
	* Externally callable function to test if the input field is valid
	*
	* @return {bool} True if the field is valid.
	*/
	isValid()
	{
		return this.isValueValid ( this.getValue() ) ;
	}

	getdata( school_id )
	{
		if ( school_id >= 0)
		{
			const url = Globals.APIFolder + '/schools/' + school_id + '/desiteachers'

			$.ajax({
				  type: 'GET',
				  url: url,
				  success:(data)=>{

					var status = data.status ;

					if ( status.rowsAffected == 0)
					{
						var rows = [] ;
					}
					else
					{
						if ( this.state.currentId <= 0 || this.state.currentId == null)
						{
							if ( this.props.readOnly == 'readonly')
							{
								var currentId = -1 ;
							}
							else
							{
                                if ( data.data.length == 1 )
                                {
                                    var currentId = data.data[0].user_id ;
                                }
                                else
                                {
                                    var currentId = -1 ;
                                }
                            }
						}
						else
						{
							var currentId = this.state.currentId;
						}

						var rows = data.data ;
					}

					this.setState({  loading: false , items: rows, currentId: currentId });

				  },
	    		  error:(jqXHR, textStatus, error)=>{

						bootbox.alert({
						  size: "large",
						  title: "The operation failed",
						  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack,
						  callback: function()
						  {
						  }
						})
			  		}

				});
		}
	}

	handleChange(e)
	{
		if ( this.props.readOnly != 'readonly' )
		{

			var targetName = e.target.name ;
			var val = e.target.value ;
			var index = e.target.selectedIndex;

			// Need to calculate the offset to read the actual Type Id from the correct place in the table
			// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for

			var offset = 0 ;

			if ( this.props.mode == 'filter' || this.props.mode == 'list')
			{
				var offset = -1 ;
			}

			if ( index > 0 )
			{
				var item = this.state.items[index+offset] ;

				var id = item.user_id;
				var itemtext = item.firstname + " " + item.surname ;

				if ( this.props.onChange != null )
				{
					this.props.onChange (this.state.items[index+offset] );
				}

				this.setState ( {currentId: id } ) ;
			}
			else
			{
				if ( this.props.onChange != null )
				{
					this.props.onChange ( null );
				}

				this.setState ( {currentId: 0} ) ;
			}
		}
	}

    getUserId()
    {
    	return this.state.currentId ;
    }

    optionList ()
    {
        var lineList=[];

        // This element renders from the list of user types returned by the getdata() ajax function above
    	var itemArray = this.state.items ;

    	if ( itemArray != null )
        {
        	var i = 0 ;
            var len = itemArray.length;
            var row = null ;
            var typeId = null ;
            var typeText = null ;

            // If it's a filter list, add the 'ALL' option

			lineList.push(React.createElement ( 'option', {key: this.keyCount++, name: typeId, value: -1} , "Please select a Designated Person"));

            for (i=0; i<len; ++i)
            {
            	if (i in itemArray)
            	{
            		row = itemArray[i];

        			var id = row.user_id;
        			var itemText = row.firstname + " " + row.surname ;

            		lineList.push(React.createElement ( 'option', {key: this.keyCount++, name: id, value: id} , itemText));
            	}
            }
        }

        return lineList ;
    }

    getCurrentText()
    {
    	var v = 'Not Set' ;

    	var itemArray = this.state.items ;

    	if ( itemArray != null )
        {
        	var i = 0 ;
            var len = itemArray.length;
            var row = null ;

            for (i=0; i<len; ++i)
            {
        		row = itemArray[i];

        		if ( row.user_id == this.state.currentId )
    			{
        			v = row.firstname + " " + row.surname ;

        			break ;
    			}
            }
        }

    	return v;
    }

    dropdown_select ( id )
    {
    	return React.createElement ( 'select', {key: this.keyCount++,
    	value: this.state.currentId,
    	className: 'form-control',
    	id: id ,
    	readOnly: this.props.readOnly,
    	onChange: this.handleChange.bind(this)}, this.optionList() ) ;
    }

	//errorDiv ()
	//{
	//	return React.createElement ('div', {  key: this.keyCount++, className: 'input-error-invisible'} , "Invalid Value" ) ;
	//}

    optionDropdown(id)
    {
    	var lineList=[];

        lineList.push (React.createElement('label', {  key: this.keyCount++, htmlFor: this.props.id, className: 'col-form-label'}, this.props.label ));
    	lineList.push( this.dropdown_select(id));

        if ( this.props.displayErrors == true )
    	{
            lineList.push ( this.errorDiv(true) ) ;
    	}

    	return lineList ;
    }

    render()
    {
    	if ( this.state.loading == true )
    	{
	        return React.createElement('div', { key: this.keyCount++, className: ''}, "LOADING...");
    	}
    	else
    	{
    		if ( this.props.readOnly != 'readonly' )
			{
    	        return React.createElement ( 'div', {key: this.keyCount++, className: this.props.containerClassName}, this.optionDropdown('list1')) ;
			}
    		else
			{
    	        return React.createElement ( 'div', {key: this.keyCount++}, this.readOnlyField()) ;
			}
    	}
    }
};


